var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickInCircleLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tick-in-circle 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verify-email",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registered",
    transform: "translate(-32.000000, -30.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-in-circle-2",
    transform: "translate(32.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-in-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,28 C21.7319864,28 28,21.7319864 28,14 C28,6.2680135 21.7319864,0 14,0 C6.2680135,0 0,6.2680135 0,14 C0,21.7319864 6.2680135,28 14,28 Z M14,25.4545455 C7.67382923,25.4545455 2.54545455,20.3261707 2.54545455,14 C2.54545455,7.67382923 7.67382923,2.54545455 14,2.54545455 C20.3261707,2.54545455 25.4545455,7.67382923 25.4545455,14 C25.4545455,20.3261707 20.3261707,25.4545455 14,25.4545455 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7778612,17.0728232 L9.8428308,14.983656 C9.36518764,14.4679658 8.55993177,14.4371224 8.04424148,14.9147656 C7.52855118,15.3924087 7.49770788,16.1976646 7.97535102,16.7133549 L10.0074861,18.9073618 C10.9193503,19.8918614 12.456657,19.9507442 13.4411567,19.0388799 C13.5658018,18.923431 13.6779944,18.7952271 13.7758933,18.6563723 L20.1310967,9.64246962 C20.5361306,9.06798984 20.3987676,8.27393711 19.8242878,7.86890324 C19.2498081,7.46386937 18.4557553,7.60123242 18.0507214,8.1757122 L11.7778612,17.0728232 Z",
    id: "Path-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickInCircleLarge);
export default __webpack_public_path__ + "static/media/TickInCircleLARGE.b8d7d84dbca407e8b31b6cba9c221c71.svg";
export { ForwardRef as ReactComponent };